// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e3ecaa0c","453":"69143cf6","781":"377cb12f","902":"2a30b0fb","924":"390bcf77"}[chunkId] + ".chunk.js";
};